import type { IconSvgObject } from './types';

const UserFullViewIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "5", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 9C7 10 6.00438 11.7876 6.0005 13.5C5.99477 14.0196 6.0308 15.1485 6.49906 16H8.5L10.0019 22H14.0016L15.5035 16H17.5044C17.9727 15.1485 18.0087 14.0196 18.003 13.5C17.9991 11.7856 17 10 16 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default UserFullViewIcon;
